import { selectIsInternalAdmin } from 'accessors'
import { CheckIcon } from 'components/ReusableComponents/Icons/Check'
import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import useCopyText from 'hooks/useCopyText'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { ReactComponent as CopyIcon } from './copyIcon.svg'
import styles from './Tooltip.module.scss'

const Tooltip = ({
  confirmationCode,
  subscriberHotelBookingId,
  roomBookingCode,
  rateCode,
  bookedBy,
  bookingDate,
  bookingSource,
  company,
  agencyParentName,
  subscription
}) => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  const copy = useCopyText()

  return (
    <div className={styles.tooltip}>
      {confirmationCode && (
        <div className={styles.row}>
          <span className={styles.label}>Confirmation #</span>
          <span className={styles.value}>
            <input className={styles.inputValue} value={confirmationCode} />
            <button onClick={() => copy(confirmationCode, 'confirmation #')}>
              <CopyIcon />
            </button>
          </span>
        </div>
      )}
      {isInternalAdmin && subscriberHotelBookingId && (
        <div className={styles.row}>
          <span className={styles.label}>Subscriber booking #</span>
          <span className={styles.value}>{subscriberHotelBookingId}</span>
        </div>
      )}
      {roomBookingCode && (
        <div className={styles.row}>
          <span className={styles.label}>Room booking #</span>
          <span className={styles.value}>{roomBookingCode}</span>
        </div>
      )}
      {rateCode && (
        <div className={styles.row}>
          <span className={styles.label}>Rate code</span>
          <span className={styles.value}>{rateCode}</span>
        </div>
      )}
      {bookedBy && (
        <div className={styles.row}>
          <span className={styles.label}>Booked by</span>
          <span className={styles.value}>{bookedBy}</span>
        </div>
      )}
      {bookingDate && (
        <div className={styles.row}>
          <span className={styles.label}>Booking date</span>
          <span className={styles.value}>
            {moment(bookingDate).format('MMM DD YYYY')}
          </span>
        </div>
      )}
      {bookingSource && (
        <div className={styles.row}>
          <span className={styles.label}>Booking source</span>
          <span className={styles.value}>{bookingSource}</span>
        </div>
      )}
      {company && (
        <div className={styles.row}>
          <span className={styles.label}>Company</span>
          <span className={styles.value}>{company}</span>
        </div>
      )}
      {agencyParentName && (
        <div className={styles.row}>
          <span className={styles.label}>Agency</span>
          <span className={styles.value}>{agencyParentName}</span>
        </div>
      )}
      {subscription && (
        <div className={styles.row}>
          <span className={styles.label}>Subscription</span>
          <span className={styles.value}>
            {subscription ? <CheckIcon /> : <CrossIcon />}
          </span>
        </div>
      )}
    </div>
  )
}

export default Tooltip
